import { createEntityAdapter } from '@reduxjs/toolkit';

import type { Tile } from '@/store/tiles/types.ts';

export const tilesAdapter = createEntityAdapter<Tile, Tile['tileId']>({
  selectId: (tile) => tile.tileId,
});

export const tilesAdapterSelectors = tilesAdapter.getSelectors();
